module.exports = __webpack_public_path__ + "img/setting.0bda92eb.svg";